<template>

  <!-- Display a smaller section for project terms. -->
  <div class="terms">
    <p @click="routeTo('/terms')">Terms & Conditions</p>
		<p @click="routeTo('/attributions')">Attributions</p>
		<span>
			 <p id="superfarm-attribution" @click.stop="openUrl('https://superfarm.com/')">🤍</p>
		</span>
  </div>
</template>

<script>
'use strict';

// Export the default component.
export default {
  components: {
  },

  methods: {
    openUrl(url) {
      window.open(url, '_blank');
    },

    routeTo(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  display: flex;
  justify-content: flex-end;
  padding: 20px;
  padding-bottom: 0px;

  .logo {
    width: 240px;
    max-width: 100%;
    margin-right: auto;
    margin-bottom: 0px;
    cursor: pointer;
    transition: all 500ms ease;

    &:active {
      transform: scale(0.9);
    }
  }

  .link {
    display: flex;
    padding: 15px 20px;
    align-items: center;
    border-radius: 40px;
    transition: background-color 200ms cubic-bezier(0.215, 0.61, 0.355, 1);
    color: white;
    text-decoration: none;
    font-size: 16px;
    background-color: transparent;
    border: none;
    height: fit-content;
    white-space: nowrap;

    &:hover {
      cursor: pointer;
      background-color: hsla(0, 0%, 100%, 0.1);
    }

    &:active {
      background-color: hsla(0, 0%, 100%, 0.2);
    }
  }
}

.terms {
	height: 100%;
  display: flex;
  justify-content: flex-end;
	align-items: center;
  padding-top: 20px;
	padding-right: 20px;

  p {
    cursor: pointer;
    color: white;
    opacity: 0.7;
    text-decoration: underline;
		padding-right: 10px;

    &:hover {
      text-decoration: none;
    }
  }

  .top {
    text-decoration: none;
    margin-right: 20px;
  }
}

#superfarm-attribution {
	display: flex;
	text-decoration: none;
}

@media (max-width: 1200px) {
  .footer {
    flex-wrap: wrap;
    justify-content: center;
    .logo {
      display: flex;
      justify-content: center;
      width: 100%;
      margin-bottom: 10px;
    }
  }

  .terms {
    justify-content: center;
  }

  .top {
    display: none;
  }
}
</style>
